import api from 'api';
import storage from "@/cflow/storageService";

class AssinaturaService {

    listar(dados, skip) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/assinatura?skip='+skip+'&token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    opcoesFiltro() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/usuarios?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new AssinaturaService();